<template>
    <div v-if="other_endpoint.boxed_link !== null">
        <a class="article-image-link" href="#" :title="other_endpoint.boxed_link.title">
            <img :src="other_endpoint.boxed_link.media.image_urls.large" />
        </a>
        <div class="quiz__campaign__endpoint_endpoint-content subtitle">
            <h4 class="quiz__campaign__endpoint-subtitle">EXPLORE A MOMENT</h4>
        </div>
        <div class="quiz__campaign__endpoint_endpoint-content title">
            <h2 class="quiz__campaign__endpoint-title">{{ other_endpoint.boxed_link.title }}</h2>
            <a v-if="other_endpoint.links" :href="other_endpoint.links.view" class="quiz__campaign__endpoint-button quiz__campaign__endpoint-button-primary">{{ other_endpoint.boxed_link.button_text }}</a>
        </div>
    </div>
</template>
<script>
export default {
    props: ['content'],
    mounted(){
        if( this.content.data !== null ) this.other_endpoint = this.content.data[0];
    },
    methods: {
        goToNewEndpoint(){
            let vm = this;
            Event.$emit('endpoint_changed', { endpoint : vm.other_endpoint, loading : true, is_active : false });
        },
    },
    data() {
        return {
            other_endpoint: {
                boxed_link: null
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/content-blocks/endpoint.vue